export default {
  home: {
    welcomeMessageForUnauth: `Let 3000 year of wisdom help you to answer questions about your love life,
      relationships, investments or other life questions.`,
    askTitle: `What question you want answered?`,
    askPlaceholder: "Type your question.....",
  },
};
